// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4658":"f3e1b3f8","6993":"1f94869c"}[chunkId] + ".chunk.css";
};